/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
         $('.eheights').matchHeight();
         $(document).on('click', '.title-bar a', function(e){ 
              e.preventDefault(); 
              var url = $(this).attr('href'); 
              window.open(url, '_blank');
          });
         $(document).on('click', '.small-content a', function(e){ 
              e.preventDefault(); 
              var url = $(this).attr('href'); 
              window.open(url, '_blank');
          });
         $(document).on('click', '.entry-content a', function(e){ 
              e.preventDefault(); 
              var url = $(this).attr('href'); 
              window.open(url, '_blank');
          });

         if ($("body").hasClass("page-template-template-program")) {
          
          var szombat21 = new Date("21 Apr 2018").toDateString();
          var vasarnap22 = new Date("22 Apr 2018").toDateString();
          var hetfo23 = new Date("23 Apr 2018").toDateString();
          var kedd24 = new Date("24 Apr 2018").toDateString();
          var szerda25 = new Date("25 Apr 2018").toDateString();
          var csutortok26 = new Date("26 Apr 2018").toDateString();
          var pentek27 = new Date("27 Apr 2018").toDateString();
          var szombat28 = new Date("28 Apr 2018").toDateString();
          var vasarnap29 = new Date("29 Apr 2018").toDateString();

          var today = new Date().toDateString();

          if($("body").attr('id') === "hu_HU"){
            if(szombat21 === today){
              var href1 = 'http://www.szentgyorgynapok.ro/program/#wcs-tabs-1=0'; 
              window.location.href = href1; 
            }else if(vasarnap22 === today){
              var href2 = 'http://www.szentgyorgynapok.ro/program/#wcs-tabs-1=1';
              window.location.href = href2; 
            }else if(hetfo23 === today){
              var href3 = 'http://www.szentgyorgynapok.ro/program/#wcs-tabs-1=2';
              window.location.href = href3; 
            }else if(kedd24 === today){
              var href4 = 'http://www.szentgyorgynapok.ro/program/#wcs-tabs-1=3';
              window.location.href = href4; 
            }else if(szerda25 === today){
              var href5 = 'http://www.szentgyorgynapok.ro/program/#wcs-tabs-1=4';
              window.location.href = href5; 
            }else if(csutortok26 === today){
              var href6 = 'http://www.szentgyorgynapok.ro/program/#wcs-tabs-1=5';
              window.location.href = href6; 
            }else if(pentek27 === today){
              var href7 = 'http://www.szentgyorgynapok.ro/program/#wcs-tabs-1=6';
              window.location.href = href7; 
            }else if(szombat28 === today){
              var href8 = 'http://www.szentgyorgynapok.ro/program/#wcs-tabs-1=7';
              window.location.href = href8; 
            }else if(vasarnap29 === today){
              var href9 = 'http://www.szentgyorgynapok.ro/program/#wcs-tabs-1=8';
              window.location.href = href9; 
            }
          }else if($("body").attr('id') === "ro_RO"){
            if(szombat21 === today){
              var href10 = 'http://www.szentgyorgynapok.ro/ro/programe/#wcs-tabs-1=0';
              window.location.href = href10; 
            }else if(vasarnap22 === today){
              var href11 = 'http://www.szentgyorgynapok.ro/ro/programe/#wcs-tabs-1=1';
              window.location.href = href11; 
            }else if(hetfo23 === today){
              var href12 = 'http://www.szentgyorgynapok.ro/ro/programe/#wcs-tabs-1=2';
              window.location.href = href12; 
            }else if(kedd24 === today){
              var href13 = 'http://www.szentgyorgynapok.ro/ro/programe/#wcs-tabs-1=3';
              window.location.href = href13; 
            }else if(szerda25 === today){
              var href14 = 'http://www.szentgyorgynapok.ro/ro/programe/#wcs-tabs-1=4';
              window.location.href = href14; 
            }else if(csutortok26 === today){
              var href15 = 'http://www.szentgyorgynapok.ro/ro/programe/#wcs-tabs-1=5';
              window.location.href = href15; 
            }else if(pentek27 === today){
              var href16 = 'http://www.szentgyorgynapok.ro/ro/programe/#wcs-tabs-1=6';
              window.location.href = href16; 
            }else if(szombat28 === today){
              var href17 = 'http://www.szentgyorgynapok.ro/ro/programe/#wcs-tabs-1=7';
              window.location.href = href17; 
            }else if(vasarnap29 === today){
              var href18 = 'http://www.szentgyorgynapok.ro/ro/programe/#wcs-tabs-1=8';
              window.location.href = href18; 
            }
          } 
        }//end check program page
          
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'program': {
      init: function() {
        // JavaScript to be fired on the about us page
        //$('.wcs-filters').append('<a id="btn-clear">Clear</a>');
        //$('#btn-clear').click(function(){
           // $("input[type='checkbox']").attr("checked",false);
        //}); 

         $('.wcs-filters').matchHeight();
         $('.wcs-timetable').matchHeight();


         $('[data-toggle="collapse"].pm').on('click', function() {
                var $this = $(this),
                        $parent = typeof $this.data('parent')!== 'undefined' ? $($this.data('parent')) : undefined;
                if($parent === undefined) { /* Just toggle my  */
                    $this.find('.zmdi').toggleClass('zmdi-plus-circle-o zmdi-minus-circle-outline');
                    return true;
                }
 
                /* Open element will be close if parent !== undefined */
                var currentIcon = $this.find('.zmdi');
                currentIcon.toggleClass('zmdi-plus-circle-o glyphicon-minus');
                $parent.find('.zmdi').not(currentIcon).removeClass('zmdi-minus-circle-outline').addClass('zmdi-plus-circle-o');

            });
      }
    } 
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
